import { DndContext, DragOverlay, pointerWithin } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import useReorderMedicalProvider from '../../hooks/useReorderMedicalProvider';
import { getFileId } from '../../utils/medicalReorderHelpers';
import SortProvider from './SortProvider';
import SortFile from './SortFile';
import DroppableNewProvider from './DroppableNewProvider';
import ReorderActions from './ReorderActions';
import { formBackgroundClasses, formItemPdClasses } from '../common/formClasses';

const ReorderMedicalProvider = ({ providerType, heading }) => {
    const {
        medicalRecords,
        isShowReorderSec,
        sensors,
        handleCancelReorder,
        handleSaveReorder,
        activeId,
        setActiveId,
        newProviderName,
        setNewProviderName,
        NEW_PROVIDER_DROP_ID,
        getProviderId,
        getActiveDragFile,
        onDragEnd,
        handleMoveWithFeedback,
    } = useReorderMedicalProvider({ providerType });

    return (
        <>
            {medicalRecords?.length > 0 && isShowReorderSec[providerType] && (
                <div className={`${formBackgroundClasses} ${formItemPdClasses}`}>
                    <div className="flex justify-between items-center mb-6">
                        <h3>{heading}</h3>
                        <ReorderActions onCancel={handleCancelReorder} onSave={handleSaveReorder} />
                    </div>

                    <DndContext
                        sensors={sensors}
                        collisionDetection={pointerWithin}
                        onDragStart={({ active }) => setActiveId(active.id)}
                        onDragEnd={onDragEnd}
                        onDragCancel={() => setActiveId(null)}
                    >
                        <SortableContext
                            items={(medicalRecords || []).map((provider, index) => getProviderId(provider, index))}
                            strategy={verticalListSortingStrategy}
                        >
                            {medicalRecords?.map((provider, index) => {
                                const providerId = getProviderId(provider, index);
                                return (
                                    <SortProvider key={providerId} id={providerId} providerIndex={index} providerType={providerType}>
                                        <SortableContext
                                            items={provider.source.map((file, fileIndex) => getFileId(providerId, file, fileIndex))}
                                            strategy={verticalListSortingStrategy}
                                        >
                                            {provider?.source.map((file, fileIndex) => {
                                                const fileId = getFileId(providerId, file, fileIndex);
                                                return (
                                                    <SortFile
                                                        key={fileId}
                                                        id={fileId}
                                                        entry={file.name}
                                                        onMoveDown={() => handleMoveWithFeedback(providerId, fileId, 'down')}
                                                        onMoveUp={() => handleMoveWithFeedback(providerId, fileId, 'up')}
                                                        isFirst={fileIndex === 0}
                                                        isLast={fileIndex === provider.source.length - 1}
                                                        orderIndex={fileIndex}
                                                    />
                                                );
                                            })}
                                        </SortableContext>
                                    </SortProvider>
                                );
                            })}
                        </SortableContext>
                        <DragOverlay>
                            {activeId ? (() => {
                                const active = getActiveDragFile();
                                return active ? (
                                    <SortFile
                                        id={activeId}
                                        entry={active.file.name}
                                        orderIndex={active.fileIndex}
                                        isFirst={false}
                                        isLast={false}
                                    />
                                ) : null;
                            })() : null}
                        </DragOverlay>
                        <DroppableNewProvider
                            dropId={NEW_PROVIDER_DROP_ID}
                            providerName={newProviderName}
                            onChange={setNewProviderName}
                        />
                    </DndContext>
                    <ReorderActions onCancel={handleCancelReorder} onSave={handleSaveReorder} />
                </div>
            )}
        </>
    );
};

export default ReorderMedicalProvider;